module.exports = __webpack_public_path__ + "static/media/logout.df3ace83.svg";